module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "div"
  }, [_c('div', {
    staticClass: "statement"
  }, _vm._l((_vm.model), function(item) {
    return _c('ul', {
      key: item.id,
      attrs: {
        "id": "lists"
      }
    }, [_c('li', [_c('p', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.store))]), _vm._v(" "), _c('p', {
      staticClass: "uite"
    }, [_vm._v(_vm._s(item.count))])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27ee3788","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Report.vue
// module id = 411
// module chunks = 1